module.exports = __webpack_public_path__ + "static/media/campus_27.8dad220e.png";